import { io } from "socket.io-client";
 
export const Socket = io("https://app.artharlem.org", {
  autoConnect: false,
  path: "/socket.io",
  transports: ["websocket"],
});